import React from "react";

import { Button } from "superbid-ui";

import setaImg from "../../assets/img/seta.svg";
import step1Img from "../../assets/img/step_1.svg";
import step2Img from "../../assets/img/step_2.svg";
import step3Img from "../../assets/img/step_3.svg";
import { login, register } from "../../commons/utils/Utils";
import { ActionButtons } from "./actionButtons";
import styles from "./singIn.module.scss";
interface SingInProps {
    showButton: boolean;
    children?: any;
}

export const SingIn: React.FC<SingInProps> = ({ children, showButton }) => {
    return (
        <div className={styles.box}>
            <div className={styles.box__ilustration}>
                <div className={styles.box__ilustration__alert}>
                    <div className={styles.box__ilustration__alert__image}>
                        <img src={step1Img} width="100%" height="100%" alt="" />
                    </div>
                    <span className={styles.box__ilustration__alert__text}>
                        Você ainda não tem alertas. Crie seu primeiro!
                    </span>
                </div>
                <div className={styles.box__ilustration__seta}>
                    <img src={setaImg} width="100%" height="100%" alt="" />
                </div>
                <div className={styles.box__ilustration__alert}>
                    <div className={styles.box__ilustration__alert__image}>
                        <img src={step2Img} width="100%" height="100%" alt="" />
                    </div>
                    <span className={styles.box__ilustration__alert__text}>
                        Escolha as características dos itens que te interessam
                    </span>
                </div>
                <div className={styles.box__ilustration__seta}>
                    <img src={setaImg} width="100%" height="100%" alt="" />
                </div>
                <div className={styles.box__ilustration__alert}>
                    <div className={styles.box__ilustration__alert__image}>
                        <img src={step3Img} width="100%" height="100%" alt="" />
                    </div>
                    <span className={styles.box__ilustration__alert__text}>
                        Receba emails assim que estiverem disponíveis para
                        lances
                    </span>
                </div>
            </div>

            <ActionButtons
                styles={styles}
                handleLogin={() => window.location.href = login()}
                handleRegister={() => window.location.href = register()}
                hidden={!showButton}
            />
        </div>
    );
};
